import { Suspense, useEffect } from "react";

import useScreenBreakpoint from "@/hooks/useScreenBreakPoint";
import LoadingIndicator from "@shared/LoadingIndicator";
import WarningScreen from "@shared/WarningScreen";

interface IProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<IProps> = ({ children }) => {
  const isBelowBreakpoint = useScreenBreakpoint(1023);

  // Debug: Log screen size
  useEffect(() => {
    console.log("PublicLayout - Screen width:", window.innerWidth, "isBelowBreakpoint:", isBelowBreakpoint);
  }, [isBelowBreakpoint]);

  if (isBelowBreakpoint) {
    return <WarningScreen />;
  }

  return (
    <Suspense fallback={<LoadingIndicator />}>
      {children}
    </Suspense>
  );
};

export default PublicLayout;
